import { render, staticRenderFns } from "./Logistica-e-spedizioni.vue?vue&type=template&id=1243a464&scoped=true&"
import script from "./Logistica-e-spedizioni.vue?vue&type=script&lang=js&"
export * from "./Logistica-e-spedizioni.vue?vue&type=script&lang=js&"
import style0 from "./Logistica-e-spedizioni.vue?vue&type=style&index=0&id=1243a464&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1243a464",
  null
  
)

export default component.exports